import React from 'react';
import { Image, StyleSheet, View } from './base_components';

const styles = StyleSheet.create({
  dialogScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#ededed',
  },
  topLine: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '25rem',
    height: '5rem',
    filter: 'var(--icon-login-dialog)',
  },
  boxView: {
    alignSelf: 'stretch',
    margin: '2rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  box: {
    flex: 1,
    padding: '3rem',
    maxWidth: '40rem',
    backgroundColor: '#fefefe',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    borderWidth: 1,
    borderColor: '#c7c7c7',
  },
});
const LOGO = require('../assets/img/logo.png');

export default function DialogScreen(props) {
  return (
    <View style={styles.dialogScreen}>
      <View style={styles.topLine}>
        <Image style={styles.image} source={LOGO} />
      </View>
      <View style={styles.boxView}>
        <View style={styles.box}>{props.children}</View>
      </View>
    </View>
  );
}
